import { defineMessages } from 'react-intl.macro';

export const organizationMessages = defineMessages({
  name: {
    id: 'organization.name',
    defaultMessage: 'Název',
  },
  ico: {
    id: 'organization.ico',
    defaultMessage: 'IČ',
  },
  dic: {
    id: 'organization.dic',
    defaultMessage: 'DIČ',
  },
  address: {
    id: 'organization.address',
    defaultMessage: 'Adresa',
  },
  note: {
    id: 'organization.note',
    defaultMessage: 'Poznámka',
  },
  search: {
    id: 'organization.search',
    defaultMessage: 'Fulltext',
  },
});

export const organizationBtnMessages = defineMessages({
  filterSubmit: {
    id: 'organization.btn.filterSubmit',
    defaultMessage: 'Filtrovat',
  },
  filter: {
    id: 'organization.btn.filter',
    defaultMessage: 'Filtr',
  },
  clear: {
    id: 'organization.btn.clear',
    defaultMessage: 'Vyčistit',
  },
  save: {
    id: 'organization.btn.save',
    defaultMessage: 'Uložit',
  },
});

export const organizationListMessages = defineMessages({
  pageTitle: {
    id: 'organization.list.page.title',
    defaultMessage: 'Přehled organizací',
  },
  loadQueryStateWaiting: {
    id: 'organization.list.queryState.load.waiting',
    defaultMessage: 'Seznam organizací se načítá.',
  },
  loadQueryStateFail: {
    id: 'organization.list.queryState.load.fail',
    defaultMessage: 'Seznam organizací se nepovedlo načíst.',
  },
  filterQueryStateEmpty: {
    id: 'organization.list.queryState.filter.empty',
    defaultMessage: 'Zadanému filtru neodpovídá žádný záznam.',
  },
});

export const organizationFormMessages = defineMessages({
  organizationDetailTitle: {
    id: 'organization.organizationDetail.title',
    defaultMessage: '{id, select, empty {Organizace} other {Organizace č. {id}}}',
  },
  delete: {
    id: 'organization.form.delete',
    defaultMessage: 'Smazat',
  },
  save: {
    id: 'organization.form.save',
    defaultMessage: 'Uložit',
  },
  dicError: {
    id: 'organization.form.dic.error',
    defaultMessage: 'Maximální délka je 10 znaků',
  },
  nameError: {
    id: 'organization.form.name.error',
    defaultMessage: 'Vyplňte název organizace',
  },
  queryStateWaiting: {
    id: 'organization.form.query.load.waiting',
    defaultMessage: 'Čekejte prosím...',
  },
  loadQueryStateFail: {
    id: 'organization.form.query.load.fail',
    defaultMessage: 'Zobrazení informací o organizaci se nepovedlo. Zkuste to prosím později.',
  },
  submitQueryStateFail: {
    id: 'organization.form.query.submit.fail',
    defaultMessage: 'Uložení změn se nepovedlo. Zkuste to prosím později.',
  },
  submitQueryStateSuccess: {
    id: 'organization.form.query.submit.success',
    defaultMessage: 'Úpravy uloženy.',
  },
  deleteConfirm: {
    id: 'organization.form.alert.delete',
    defaultMessage: 'Opravdu si přejete smazat organizaci?',
  },
});
